import React from "react";

const ContactSection = () => {
  return (
    <>
      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid ">
          <div className="page-heading">
            <h1 className="text-center">Contact Us</h1>
          </div>
        </div>
      </div>

      <section className="contact-section  p-0 fix  p-0 py-3">
        <div className="shape-1 ">
          <img src="/img/01.png" alt="shape" />
        </div>

        <div className="shape-2">
          <img src="/img/02.png" alt="shape" />
        </div>

        <div className="container  p-0">
          <div className="contact-wrapper   p-0 p-2">

            <div className="section-title text-center mb-4  p-0">
            </div>

            {/* <p className="text-center mb-5">
              We offer reliable cab services for local and outstation travel.
              Reach out to us anytime for bookings or support.
            </p> */}

            {/* ✅ 3 COLUMN LAYOUT */}
            <div className="row g-  p-0">

             

              {/* PHONE */}
              <div className="col-md-3 col-12 ">
                <div className="contact-items text-center ">
                  <div className="icon">📞</div>
                  <div className="content">
                    <span>Phone Number</span>
                    <h5>
                      <a href="tel:+919529877342">+91 9529877342</a>
                    </h5>
                  </div>
                </div>
              </div>

              {/* EMAIL */}
              <div className="col-md-3 col-12">
                <div className="contact-items text-center">
                  <div className="icon">✉️</div>
                  <div className="content">
                    <span>Email Address</span>
                    <h5>
                      <a href="mailto:booking@royalroutecabs.com">
                        booking@royalroutecabs.com
                      </a>
                    </h5>
                  </div>
                </div>
              </div>



               {/* LOCATION */}
              <div className="col-md-3 col-12">
                <div className="contact-items text-center">
                  <div className="icon">📍</div>
                  <div className="content">
                    <span>Our Location Mumbai</span>
                    <h6>Royal Route Cab</h6>
                    <h5>
                        
                        
                 
Shop Number 57,
Prabhat Colony Opp.
Panbai International School
Vimladevi Road,Santacruz(E)
Mumbai Maharashtra-400055.
</h5>
                  </div>
                </div>
              </div>




              
               {/* LOCATION */}
              <div className="col-md-3 col-12">
                <div className="contact-items text-center">
                  <div className="icon">📍</div>
                  <div className="content">
                    <span>Our Location Pune</span>
                    <h6>Royal Route Cab</h6>
                    <h5>
                        
                        
                 
Survey no 51/1, Shreyas building, Krishna chowk opposite bank of baroda, Sangavi, Pune 411027,  Maharashtra
</h5>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>


        <div className="map-section">
      <div className="google-map">
      



<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2872.0636884852793!2d72.8448611!3d19.085527799999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTnCsDA1JzA3LjkiTiA3MsKwNTAnNDEuNSJF!5e1!3m2!1sen!2sin!4v1775967256303!5m2!1sen!2sin" 
  style={{ border: 0, width: "100%", height: "450px" }}
allowfullscreen=""

loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

      </div>
    </div>
    </>
  );
};

export default ContactSection;